import { render, staticRenderFns } from "./AgentActivitiesReportCard.vue?vue&type=template&id=85972840&scoped=true"
import script from "./AgentActivitiesReportCard.vue?vue&type=script&lang=js"
export * from "./AgentActivitiesReportCard.vue?vue&type=script&lang=js"
import style0 from "./AgentActivitiesReportCard.vue?vue&type=style&index=0&id=85972840&prod&lang=scss"
import style1 from "./AgentActivitiesReportCard.vue?vue&type=style&index=1&id=85972840&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85972840",
  null
  
)

export default component.exports